import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import axios from "axios";
import config from "../../config/config";
import Popupform from '../../Components/Popupform/Popupform';
import Boucherpopup from '../../Components/Popupform/Boucherpopup';
import { FiDownload, FiArrowRight, FiMapPin, FiAward, FiDollarSign } from 'react-icons/fi';

const CollageTable = ({ courseName }) => {
    const [showPopup, setShowPopup] = useState(false);
    const [showBoucherPopup, setShowBoucherPopup] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const handleOpenPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleOpenBoucherPopup = (e) => {
        if (e) e.preventDefault();
        setShowBoucherPopup(true);
    };

    const handleCloseBoucherPopup = () => {
        setShowBoucherPopup(false);
    };

    useEffect(() => {
        return () => { document.body.style.overflow = "auto"; };
    }, []);

    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const response = await axios.get(
                    `${config.API_BASE_URL}/api/admin/get_collegespageByCourse/${courseName}`
                );
                setTableData(response.data.collegesByCourseName || []);
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };
        fetchCollegeData();
    }, [courseName]);

    const totalPages = Math.ceil(tableData.length / itemsPerPage);
    const paginatedData = tableData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <div className="container mx-auto px-4 py-10">
            {/* Table Container */}
            <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden mb-8">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-[800px]">
                        <thead className="bg-gray-50 border-b border-gray-100">
                            <tr>
                                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Rank</th>
                                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider w-[40%]">College Info</th>
                                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Fees</th>
                                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Placement</th>
                                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">Ranking</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {paginatedData.map((item, index) => (
                                <tr key={index} className="hover:bg-orange-50/30 transition-colors group">
                                    <td className="px-6 py-4 whitespace-nowrap text-center font-bold text-gray-400 group-hover:text-brand-orange">
                                        #{(currentPage - 1) * itemsPerPage + index + 1}
                                    </td>

                                    <td className="px-6 py-4">
                                        <div className="flex items-start gap-4">
                                            <div className="w-12 h-12 bg-white rounded-lg border border-gray-100 p-1 flex-shrink-0 flex items-center justify-center">
                                                <img
                                                    src={`${config.API_BASE_URL}/${item.image}`}
                                                    alt="College Logo"
                                                    className="max-w-full max-h-full object-contain"
                                                />
                                            </div>
                                            <div>
                                                <NavLink to={`/college/${item._id}`} className="text-lg font-bold text-gray-800 hover:text-brand-orange transition block mb-1">
                                                    {item.collegeName}
                                                </NavLink>
                                                <div className="flex items-center text-xs text-gray-500 mb-1">
                                                    <FiMapPin className="mr-1" /> {item.city}
                                                </div>
                                                <p className="text-xs text-gray-400 mb-3">{item.subheading}</p>

                                                <div className="flex flex-wrap gap-2 text-xs">
                                                    <button onClick={handleOpenPopup} className="flex items-center font-bold text-brand-orange hover:bg-orange-50 px-2 py-1 rounded transition">
                                                        Apply Now <FiArrowRight className="ml-1" />
                                                    </button>
                                                    <span className="text-gray-300">|</span>
                                                    <button onClick={handleOpenBoucherPopup} className="flex items-center font-medium text-gray-600 hover:text-brand-orange px-2 py-1 rounded transition">
                                                        <FiDownload className="mr-1" /> Brochure
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="font-bold text-gray-800">&#8377; {item.fee}</div>
                                        <div className="text-xs text-gray-500">{item.coursename}</div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap">
                                        <div className="mb-2">
                                            <div className="font-bold text-green-600">&#8377; {item.placementavg}</div>
                                            <div className="text-[10px] text-gray-400 uppercase font-bold">Avg Package</div>
                                        </div>
                                        <div>
                                            <div className="font-bold text-gray-800">&#8377; {item.placementhig}</div>
                                            <div className="text-[10px] text-gray-400 uppercase font-bold">Highest Package</div>
                                        </div>
                                    </td>

                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                        <div className="flex items-center gap-2">
                                            <FiAward className="text-brand-orange" />
                                            #1th/762 in India
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-4">
                    <span className="text-sm font-bold text-gray-600">Page:</span>
                    <div className="relative">
                        <select
                            value={currentPage}
                            onChange={(e) => setCurrentPage(Number(e.target.value))}
                            className="appearance-none bg-white border border-gray-200 text-gray-700 py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:border-brand-orange focus:ring-1 focus:ring-brand-orange shadow-sm text-sm font-bold cursor-pointer"
                        >
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <option key={page} value={page}>Page {page}</option>
                            ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                            </svg>
                        </div>
                    </div>
                </div>
            )}

            {/* Popups */}
            {showPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleClosePopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}

            {showBoucherPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleCloseBoucherPopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Boucherpopup />
                    </div>
                </div>
            )}
        </div>
    );
};

export default CollageTable;
